import {useDateRange} from "@/components/datePicker/DatePickerURLRangeParamsContext.ts";
import {Last30Days} from "@/components/datePicker/subComponents/DatePickerShortcutList/DatePickerShortcutList.utils.ts";
import {formatDate} from "@/components/dateUtils.tsx";
import {DropdownItem} from "@/components/dropdown/subComponents/DropdownItem/DropdownItem.tsx";
import {DropdownButton} from "@/components/dropdownButton/DropdownButton.tsx";
import {BrandInfo} from "@/lib/queries/accounts.ts";

interface DownloadCheckReportProps {
  brand: BrandInfo;
  id: number;
}

export const DownloadCheckReport = ({id, brand}: DownloadCheckReportProps) => {
  const {currentParamDateRange} = useDateRange({
    fromKey: "start",
    toKey: "end",
    fixedRangeKey: "range",
    withDefault: Last30Days,
  });

  return (
    <DropdownButton title={"Download"} size={"large"}>
      <DropdownItem
        href={`${brand.siteURL}/devices/services/${id}/pdf?start=${formatDate(currentParamDateRange.from)}&end=${formatDate(currentParamDateRange.to)}`}
        target="_blank"
      >
        Download PDF
      </DropdownItem>
      <DropdownItem
        href={`${brand.siteURL}/devices/services/${id}/stats?start=${formatDate(currentParamDateRange.from)}&end=${formatDate(currentParamDateRange.to)}`}
        target="_blank"
      >
        Download XLS
      </DropdownItem>
    </DropdownButton>
  );
};
